import {
  FETCH_ORG_PROFILE_DATA_REQUEST,
  UPDATE_ORG_PROFILE_TIMEZONE,
  FETCH_ORG_PROPERTY_LOCATION,
  UPDATE_ORG_IMAGE_COORDINATES,
  REMOVE_ORG_SKILLSET,
  ADD_ORG_SKILLSET,
  FETCH_LOCATION_NAMES,
  ADD_REMOVE_SERVICE_LOCATION_NAMES,
  REMOVE_ORG_LOGO,
  UPDATE_ORG_IMAGE_URL,
  FETCH_ALL_SKILSET,
  FETCH_ZIP_DATA
} from "../actions/actionConstants";

export const fetchOrgProfileData = payload => ({
  type: FETCH_ORG_PROFILE_DATA_REQUEST,
  payload
});

export const updateOrgProfileTimzeone = payload => ({
  type: UPDATE_ORG_PROFILE_TIMEZONE,
  payload
});

export const getOrgLocationByZip = payload => ({
  type: FETCH_ORG_PROPERTY_LOCATION,
  payload
});

export const updateOrganizationLogo = payload => ({
  type: UPDATE_ORG_IMAGE_COORDINATES,
  payload
})

export const updateOrganizationImageURl = payload => ({
  type: UPDATE_ORG_IMAGE_URL,
  payload
})


export const addTagForOrg = payload => ({
  type: ADD_ORG_SKILLSET,
  payload
})

export const removeTagForOrg = payload => ({
  type: REMOVE_ORG_SKILLSET,
  payload
})

export const fetchAllSkilset = payload => ({
  type: FETCH_ALL_SKILSET,
  payload
})

export const fetchServiceLocData = payload => ({
  type: FETCH_LOCATION_NAMES,
  payload
})

export const fetchZipData = payload => ({
  type: FETCH_ZIP_DATA,
  payload
})

export const addOrRemoveServiceLocNames = payload => ({
  type: ADD_REMOVE_SERVICE_LOCATION_NAMES,
  payload
})


export const removeOrgLogo = payload => ({
  type: REMOVE_ORG_LOGO,
  payload
})




